import React, { createContext, useState, useEffect } from 'react';
import { login as loginApi, register as registerApi } from '../../api/api';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(localStorage.getItem('user') || null); // Inizializza l'utente dallo storage locale
    const [token, setToken] = useState(localStorage.getItem('token') || null); // Inizializza il token dallo storage locale

    useEffect(() => {
        // Sincronizza il token con localStorage
        if (token) {
          localStorage.setItem('token', token);
        } else {
          localStorage.removeItem('token');
        }
      }, [token]);

    const login = async (username, password, otp) => {
        const data = await loginApi(username, password, otp);
        console.log("Login data received:", data);
        setUser(username);
        setToken(data.token);
        localStorage.setItem('user', username); // Salva l'utente nel localStorage
        localStorage.setItem('token', data.token); // Salva il token nel localStorage
    };

    const register = async (username, password) => {
        await registerApi(username, password);
    };

    const logout = () => {
        setUser(null);
        setToken(null);
        localStorage.removeItem('token'); // Rimuovi il token dal localStorage
    };

    return (
        <AuthContext.Provider value={{ user, token, login, register, logout }}>
            {children}
        </AuthContext.Provider>
    );
};